import { render, staticRenderFns } from "./EMelderComponentEinstellungenMeldungsvorlagenRightElementRisikobewertung.vue?vue&type=template&id=334960e8&scoped=true"
import script from "./EMelderComponentEinstellungenMeldungsvorlagenRightElementRisikobewertung.vue?vue&type=script&lang=js"
export * from "./EMelderComponentEinstellungenMeldungsvorlagenRightElementRisikobewertung.vue?vue&type=script&lang=js"
import style0 from "./EMelderComponentEinstellungenMeldungsvorlagenRightElementRisikobewertung.vue?vue&type=style&index=0&id=334960e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334960e8",
  null
  
)

export default component.exports